import WoSectionCard from "../common/WoSectionCard";
import Notes from "../notes";

// Customer Chat section as an independent card matching the proposals/forms look.
function WoCustomerChat({ order, sendNote }) {
  return (
    <WoSectionCard
      title="Customer Chat"
      count={order.customerNotes?.length || 0}
      toolTip="This is a direct line of communication between you and the customer.<br/> However the customer will not receive your messages unless they are set up on the Customer App."
    >
      <Notes notes={order.customerNotes} sendNote={sendNote} />
    </WoSectionCard>
  );
}

export default WoCustomerChat;
